import { SplashContent } from '../../../Splash/SplashContent/SplashContent';
import { SplashImage } from '../../../Splash/SplashImage/SplashImage';

import type { ReactNode, VFC } from 'react';

import * as styles from './CarouselSplash.module.scss';

type CarouselSplashProps = {
  lazy: boolean;
  hidden: boolean;
  imageUrl: string;
  previewUrl?: string;
  onPreviewEnded?: () => void;
  title: string;
  description?: string | null;
  labels?: ReactNode[];
  badge?: ReactNode;
  buttons?: ReactNode | ReactNode[];
};

export const CarouselSplash: VFC<CarouselSplashProps> = ({
  title,
  description,
  badge,
  imageUrl,
  previewUrl,
  onPreviewEnded,
  lazy,
  hidden,
  labels,
  buttons,
}) => {
  return (
    <div className={styles.splash} aria-hidden={hidden}>
      <SplashImage
        className={styles.splashBackground}
        onPreviewEnded={onPreviewEnded}
        previewUrlProp={previewUrl}
        lazy={lazy}
        imageUrl={imageUrl}
      />

      <div className={styles.splashContentWrapper}>
        <SplashContent
          className={styles.splashContent}
          title={title}
          description={description}
          labels={labels}
          buttons={buttons}
          badge={badge}
        />
      </div>
    </div>
  );
};
